import { get } from '@/utils/client';
import useSWR from 'swr';

// API endpoints
import { WEBFLOW_ARTICLES } from '@/lib/routes/apiEndpoints';

// Types
import type { PlatformLanguagesType } from '@/types/userType';
import type { SWRConfiguration } from 'swr';

type WebflowArticleType = 'product_update' | 'blog';

export type WebflowArticle = {
    title: string;
    content: string;
    type: WebflowArticleType;
    image_url: string;
    link: string;
    date: string;
};

type UseWebflowArticlesParams = {
    params: {
        article_types?: WebflowArticleType[];
        article_count?: number;
        lang?: PlatformLanguagesType;
    };
    options?: SWRConfiguration<WebflowArticle[], Error>;
};

const useWebflowArticles = ({ params, options }: UseWebflowArticlesParams) => {
    const {
        data: articles,
        error: articlesError,
        isLoading
    } = useSWR<WebflowArticle[], Error>(
        [WEBFLOW_ARTICLES, ...Object.values(params)],
        ([url]) => get(url, params).then((res) => res?.data?.data),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    return {
        articles,
        articlesError,
        isLoading
    };
};

export default useWebflowArticles;
